import DataCenter from './index';

export default {
    path: '/home/snapshotStatistic',
    component: DataCenter
};
